const GOOGLE_AUTH_BASE = "https://accounts.google.com/o/oauth2/v2/auth";
const SCOPES = [
  "openid",
  "email",
  "profile",
  "https://www.googleapis.com/auth/calendar",
].join(" ");

export function getGoogleOAuthRedirectUri() {
  if (typeof window !== "undefined") {
    return `${window.location.origin}/oauth2callback`;
  }
  return "http://localhost:3000/oauth2callback";
}

export function getGoogleClientId() {
  return (
    process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID ||
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    process.env.GOOGLE_CLIENT_ID ||
    ""
  );
}

export function buildGoogleAuthUrl({
  clientId,
  redirectUri,
  prompt = "consent",
} = {}) {
  const resolvedClientId = clientId || getGoogleClientId();
  const resolvedRedirect = redirectUri || getGoogleOAuthRedirectUri();
  if (!resolvedClientId) {
    throw new Error("Google OAuth client ID is not configured.");
  }

  const params = new URLSearchParams({
    client_id: resolvedClientId,
    redirect_uri: resolvedRedirect,
    response_type: "code",
    scope: SCOPES,
    access_type: "offline",
    prompt,
  });
  return `${GOOGLE_AUTH_BASE}?${params.toString()}`;
}

export async function fetchGoogleOAuthPublicConfig(functions) {
  const { httpsCallable } = await import("firebase/functions");
  const fn = httpsCallable(functions, "getGoogleOAuthPublicConfig");
  const { data } = await fn();
  return data;
}

export async function getElectronGoogleOAuthParams(functions) {
  const config = await fetchGoogleOAuthPublicConfig(functions);
  const electron = config?.electron || {};
  if (!electron.clientId || !electron.redirectUri) {
    throw new Error("Electron Google OAuth is not configured on the server.");
  }
  return electron;
}

export async function getWebGoogleOAuthParams(functions) {
  const redirectUri = getGoogleOAuthRedirectUri();
  const envClientId = getGoogleClientId();

  // Prefer the web client ID baked in at build time (Vercel env). Server config is fallback.
  if (envClientId) {
    return { clientId: envClientId, redirectUri };
  }

  try {
    const config = await fetchGoogleOAuthPublicConfig(functions);
    const web = config?.web || {};
    if (web.clientId) {
      return { clientId: web.clientId, redirectUri };
    }
  } catch (error) {
    console.warn("[googleAuth] Failed to fetch web OAuth config from server:", error);
  }

  throw new Error("Google OAuth client ID is not configured.");
}

export async function redirectToGoogleAuth(functions) {
  const { clientId, redirectUri } = await getWebGoogleOAuthParams(functions);
  window.location.href = buildGoogleAuthUrl({ clientId, redirectUri });
}
